module.exports = __webpack_public_path__ + "img/vidoeType.b40b1e5a.png";